module.exports = __webpack_public_path__ + "img/13.47545d17.jpg";